import { Select } from "@chakra-ui/react";
import { useOrdersKanbanStore } from "../../../stores/kanban.store";
import { CommandType } from "../../../types/command.types";
import i18n from "../../../i18n";

const OrdersCommandTypeFilter = () => {
	const {
		filters: { type },
		setFilterType,
	} = useOrdersKanbanStore();

	return (
		<Select
			name="type"
			value={type ?? ""}
			onChange={(e) => {
				e.preventDefault();
				e.stopPropagation();
				setFilterType(e.target.value as CommandType);
			}}
			placeholder="Type de commande"
		>
			{Object.values(CommandType).map((type) => (
				<option key={type} value={type}>
					{i18n.t(`command.type.${type}`)}
				</option>
			))}
		</Select>
	);
};

export default OrdersCommandTypeFilter;
